import { downloadCertificate, certificateFile } from "@/lib/certificateLazy";
import { shareContent } from "@/lib/share";
import api from "@/lib/api";

// Certificates are a paid feature; BillingProvider keeps this flag in sync.
let certificateAccess = false;
export const setCertificateAccess = (v) => { certificateAccess = !!v; };

// Issues a certificate PDF; prompts guests for a name and logs the download for signed-in users.
// With share=true the PDF goes to the native share sheet (falls back to a download).
export function issueCertificate({ user, kind, heading, title, line, score, filename, namePrompt, share = false }) {
  if (!certificateAccess) {
    window.dispatchEvent(new CustomEvent("fab:upgrade", { detail: { feature: "certificates" } }));
    return false;
  }
  let name = user?.name || "";
  if (!name) {
    name = (window.prompt(namePrompt || "Name to print on the certificate", "") || "").trim();
    if (!name) return false;
  }
  const opts = { name, heading, line, score, date: new Date().toLocaleDateString(), filename };
  if (share) {
    certificateFile(opts).then((file) => shareContent({
      title: heading || "Certificate", text: `${name} — ${title}${score != null ? ` (${score}%)` : ""}`,
      files: [file], fallbackDownload: () => downloadCertificate(opts),
    }));
  } else downloadCertificate(opts);
  if (user) api.post("/certificates", { kind, title, score: score ?? null }).catch(() => {});
  return true;
}
